import Link from 'next/link';

import CloudinaryImage from '../common/CloudinaryImage';

import Container from './Container';

export default function PodCastBanner({ data }) {
  return (
    <section
      // style={{backgroundImage: `url(${data?.bgImage?.data?.attributes?.url})`}}
      className="lg:py-[60px] py-[40px] relative"
    >
      {data?.bgImage?.data?.attributes?.url && (
        <CloudinaryImage
          backendImgUrl={data?.bgImage?.data?.attributes?.url}
          className={`absolute top-0 bottom-0 left-0 right-0 w-full z-[0] h-full object-cover`}
          alt={data?.bgImage?.data?.attributes?.alternativeText}
          type="isDesktop"
        />
      )}
      <Container className="relative z-1">
        <div className="grid grid-cols-12 md:gap-10 gap-5">
          <div className="md:col-span-6 col-span-12 mr-10">
            <h1
              className="text-[#ffffff] text-[26px] md:text-[32px] xl:text-[50px] font-[700] lg:mb-5 mb-4 leading-tight"
              style={{ textShadow: '2px 2px 1px #0000002e' }}
            >
              {data?.h1_purple}
            </h1>
            <p className="lg:text-[20px] text-[16px] font-[400] text-[#ffffff] max-w-[1200px] lg:mb-8 mb-6">
              {data?.p}
            </p>
            <Link
              href={`${data?.href}`}
              className="bg-[#FFA030] text-[#000D3A] border border-[#ffffff] group inline-block relative rounded-[4px] overflow-hidden px-10 py-2"
            >
              <span>
                <span className="bg-[#ffffff] absolute top-0 left-0 flex w-full h-0 mb-0 transition-all duration-200 ease-out transform translate-y-0 group-hover:h-full opacity-1"></span>
                <span className="group-hover:text-[#000000] flex items-center font-[600] relative lg:text-[24px] text-[13px]">
                  {data?.button_text}
                </span>
              </span>
            </Link>

            <div className="text-[24px] text-[#FFFFFF] font-[400] mt-6 mb-4">
              {data?.AwardsText}
              <span className="border border-[#FFA030] block w-[50px]"></span>
            </div>
            <ul className="flex gap-5">
              {data?.Awards?.map((data, key) => (
                <li key={key}>
                  <CloudinaryImage
                    backendImgUrl={data?.image?.data?.attributes?.url}
                    alt={data?.image?.data?.attributes?.alternativeText}
                    className=""
                    type={'icon'}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
    </section>
  );
}
